import { BotMessage } from "./BotMessage";
import { Soribot } from "./Soribot";

export class SoribotTestCase {
  static SUBCOL = 'testcases'; // soribots/testcases

  public created = new Date();
  public questions: TestQuestion[] = [];

  constructor(public id: string, public soribotId: string, public title: string) {
  }
}

export type EvaluationMethod = 'none' | 'auto';

export class TestQuestion {
  constructor(public question: string, public evaluationMethod: EvaluationMethod = 'auto') {
  }
}

export class TestAnswer {
  public started: Date | null = null;
  public completed: Date | null = null;
  public error: string | null = null;
  public score: number | null = null;
  public feedback: string | null = null;
  public botMessage: BotMessage | null = null;

  public answer?: string; // Depricated
  public sources?: string; // Depricated

  constructor(public question: string) {
  }
}

export class SoribotTestRun {
  static COL = 'testruns'; // soribots/testruns
  public created = new Date();
  public restarted: Date | null = null;

  public answers: TestAnswer[] = [];
  public isRunning = false;
  public isEvaluating = false;
  public error: string | null = null;
  public soribot?: Soribot;

  constructor(public id: string, public testCase: SoribotTestCase) {
  }
}
